import React, { Component, ErrorInfo, Fragment } from 'react'

export interface ErrorBoundaryProps {
  notifyError?: (error: Error, info: ErrorInfo) => void
}

export interface ErrorBoundaryState {
  error?: Error
  info?: ErrorInfo
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {}
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ error, info })
    this.props.notifyError?.(error, info)
    if (process.env.NODE_ENV === 'development') {
      console.error('error boundary', { error, info })
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div>
          <h3>エラーが発生しました</h3>
          <p>
            ご不便をおかけして申し訳ありません。お手数ですが、システム管理者までお問い合わせください。
          </p>
          {process.env.NODE_ENV === 'development' && (
            <Fragment>
              <pre>{this.state.error.toString()}</pre>
              <pre>{this.state.info?.componentStack}</pre>
            </Fragment>
          )}
        </div>
      )
    }
    return this.props.children
  }
}
